module.exports = "<template>\n    <section>\n        <b-tag>Tag label</b-tag>\n        <b-tag rounded>Rounded tag label</b-tag>\n    </section>\n</template>\n"


//////////////////
// WEBPACK FOOTER
// ./node_modules/raw-loader!./docs/pages/components/tag/examples/ExSimple.vue
// module id = 1540
// module chunks = 16